var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page gc" }, [
    _c("div", { staticClass: "container g9" }, [
      _c("div", { staticClass: "inner" }, [
        _c("h1", [_vm._v("Sign in to simply.")]),
        _vm._v(" "),
        _c("h3", [_vm._v("Enter your details below")]),
        _vm._v(" "),
        _c(
          "form",
          {
            attrs: { action: "#", method: "post", id: "form" },
            on: { submit: _vm.onSubmit },
          },
          [
            _c(
              "div",
              {
                ref: "email",
                staticClass: "input",
                class: { error: _vm.emailError },
                attrs: { type: "email" },
              },
              [
                _c("label", [
                  _c("span", [_vm._v("E-mail address")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.email,
                        expression: "email",
                      },
                    ],
                    attrs: {
                      type: "email",
                      placeholder: "E-mail",
                      tabindex: "1",
                    },
                    domProps: { value: _vm.email },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.email = $event.target.value
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _vm.emailError
                  ? _c("div", { staticClass: "error-message" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.emailErrorMessage) +
                          "\n                    "
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "input",
                class: { error: _vm.passwordError },
                attrs: { type: "password" },
              },
              [
                _c("label", [
                  _c(
                    "span",
                    [
                      _vm._v("Password "),
                      !_vm.$route.query.h
                        ? _c(
                            "router-link",
                            { attrs: { to: "/forgot-password" } },
                            [_vm._v("Forgot password?")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password",
                      },
                    ],
                    attrs: {
                      type: "password",
                      placeholder: "Password",
                      tabindex: "2",
                    },
                    domProps: { value: _vm.password },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.password = $event.target.value
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _vm.passwordError
                  ? _c("div", { staticClass: "error-message" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.passwordErrorMessage) +
                          "\n                    "
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c("button", { class: { loading: _vm.isLoading } }, [
              _vm._v("Sign in"),
            ]),
          ]
        ),
        _vm._v(" "),
        _vm._m(0),
      ]),
      _vm._v(" "),
      _vm._m(1),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "okta" }, [
      _vm._v("\n                Are you using okta? Please "),
      _c("a", { attrs: { href: "Okta/SignIn" } }, [_vm._v("sign in here")]),
      _vm._v(".\n            "),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("p", [_vm._v("Sply Tech ApS - All Rights Reserved")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }